import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Footer.css";
function Footer() {
  return (
    <footer className="footer footer-transparent d-print-none p-3 p-lg-3 pt-4">
      <div>
        <Row className="align-items-center">
          <Col className="mb-3 mb-lg-0" md={6}>
            <p className="mb-0">
              Copyright &copy; 2024 &nbsp;<b>  Grok Learning Pvt Ltd  </b>&nbsp; All
              rights reserved
            </p>
          </Col>

          <Col md={6}>
            <div className="followson align-items-center d-flex justify-content-md-end">
              <span> Follow us on: </span>
              <ul className="social-links-s">
                <li>
                <a target="_blank" href="https://www.facebook.com/profile.php?id=100087656163244&mibextid=D4KYlr">
                    <img
                      src={require("../../../images/facebook (1).png")}
                      width={25}
                      height={25}
                      className="img-fluid"
                      alt="facebook"
                    />
                  </a>
                </li>
                <li>
                <a target="_blank" href="https://x.com/grovator">
                    <img
                      src={require("../../../images/twitterNew.png")}
                      width={29}
                      height={29}
                      className="img-fluid"
                      alt="twitter"
                    />
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://instagram.com/grovator.official?utm_source=qr&igshid=NGExMmI2YTkyZg%3D%3D">
                    <img
                      src={require("../../../images/instagram.png")}
                      width={25}
                      height={25}
                      className="img-fluid"
                      alt="instagram"
                    />
                  </a>
                </li>
                <li>
                <a target="_blank" href="https://www.linkedin.com/company/grovator/">
                    <img
                      src={require("../../../images/linkedin.png")}
                      width={25}
                      height={25}
                      className="img-fluid"
                      alt="linkedin"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </footer>
  );
}

export default Footer;
